<template>
  <!-- ============ ENGLISH ============ -->
  <div class="pt-5" v-if="currentLanguage == 'en'" style="background-color: #F6F9FB;">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>Free GIF Maker From Images</h1>
        <p>Create engaging GIFs easily. Fun, fast, creative, and Free.</p>
      </div>
      
      <div class="tool">
        <gif-com></gif-com>
      </div>

    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">GIF Maker Guide and FAQs</h2>
        <p class="help-subtitle">Learn how to use the SplendApp GIF Maker</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="Help topics">
        <button type="button" role="tab" id="gif-converter-en-faq-tab" aria-controls="gif-converter-en-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          Frequently Asked Questions
        </button>
        <button type="button" role="tab" id="gif-converter-en-guide-tab" aria-controls="gif-converter-en-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          Usage Guide
        </button>
      </nav>

      <!-- FAQ Pane EN -->
      <div v-show="activeTab === 'faq'" id="gif-converter-en-faq-panel" role="tabpanel" aria-labelledby="gif-converter-en-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> Technical Questions
        </div>
        <div v-for="(item, i) in enFaqTechnical" :key="'t'+i" class="faq-item" :class="{ open: openFaq === 'en-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-t-'+i ? null : 'en-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> Usage & Saving
        </div>
        <div v-for="(item, i) in enFaqUsage" :key="'u'+i" class="faq-item" :class="{ open: openFaq === 'en-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-u-'+i ? null : 'en-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> Rights & Ownership
        </div>
        <div v-for="(item, i) in enFaqRights" :key="'r'+i" class="faq-item" :class="{ open: openFaq === 'en-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'en-r-'+i ? null : 'en-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane EN -->
      <div v-show="activeTab === 'guide'" id="gif-converter-en-guide-panel" role="tabpanel" aria-labelledby="gif-converter-en-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="Search the usage guide...">
          <span class="search-icon">🔍</span>
        </div>
        <div id="guideContent">
          <div v-for="(step, i) in filteredStepsEn" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsEn.length === 0" class="no-results">Sorry, no results found.</p>
      </div>
    </section>


  </div>


  <!-- ============ ARABIC ============ -->
  <div class="pt-5" style="direction: rtl; background-color: #F6F9FB;" v-else-if="currentLanguage == 'ar'">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>صانع GIF من الصور أونلاين</h1>
        <p>صمم صور متحركة GIFs جذابة بسهولة. ممتع، سريع، إبداعي ومجاني.</p>
      </div>
      
      <div class="tool">
        <gif-com></gif-com>
      </div>

  
    </section>



    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">دليل صنع GIF والأسئلة الشائعة</h2>
        <p class="help-subtitle">تعرف على أداة صانع الـ GIF من سبلينداب</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="موضوعات المساعدة">
        <button type="button" role="tab" id="gif-converter-ar-faq-tab" aria-controls="gif-converter-ar-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          الأسئلة الشائعة
        </button>
        <button type="button" role="tab" id="gif-converter-ar-guide-tab" aria-controls="gif-converter-ar-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          دليل الاستخدام
        </button>
      </nav>

      <!-- FAQ Pane AR -->
      <div v-show="activeTab === 'faq'" id="gif-converter-ar-faq-panel" role="tabpanel" aria-labelledby="gif-converter-ar-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> أسئلة تقنية
        </div>
        <div v-for="(item, i) in arFaqTechnical" :key="'art'+i" class="faq-item" :class="{ open: openFaq === 'ar-t-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-t-'+i ? null : 'ar-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> الاستخدام والحفظ
        </div>
        <div v-for="(item, i) in arFaqUsage" :key="'aru'+i" class="faq-item" :class="{ open: openFaq === 'ar-u-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-u-'+i ? null : 'ar-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> الحقوق والملكية
        </div>
        <div v-for="(item, i) in arFaqRights" :key="'arr'+i" class="faq-item" :class="{ open: openFaq === 'ar-r-'+i }">
          <div class="faq-question" @click="openFaq = openFaq === 'ar-r-'+i ? null : 'ar-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane AR -->
      <div v-show="activeTab === 'guide'" id="gif-converter-ar-guide-panel" role="tabpanel" aria-labelledby="gif-converter-ar-guide-tab" class="tab-pane">
        <div class="search-box">
          <input type="text" v-model="guideSearch" placeholder="ابحث في دليل الاستخدام...">
          <span class="search-icon">🔍</span>
        </div>
        <div>
          <div v-for="(step, i) in filteredStepsAr" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsAr.length === 0" class="no-results">عذراً، لم نجد نتائج تطابق بحثك.</p>
      </div>
    </section>


  </div>
</template>

<script>
import GifCom from '@/components/GifCom.vue'
import ToolsComen from '@/components/ToolsComen.vue';
import ToolsComar from '@/components/ToolsComar.vue';

export default {
  name: 'GifMakerPage',
  components: { GifCom, ToolsComen, ToolsComar },
  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      title: '',
      description: '',
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // ─── English FAQ Data ──────────────────────────────────────
      enFaqTechnical: [
        {
          q: 'Why does image quality appear slightly lower after converting to GIF?',
          a: 'The GIF format uses a limited color palette (only 256 colors). For best quality, we recommend using images with solid backgrounds and minimizing complex color gradients.'
        },
        {
          q: 'Does the tool support images with transparent backgrounds (PNG)?',
          a: 'Yes, the tool preserves transparency in uploaded PNG images. Make sure to choose a transparent or compatible background color that matches your application for a professional look.'
        },
        {
          q: 'What is the maximum file size for the resulting GIF?',
          a: "We don't set limits, but platforms like WhatsApp and Instagram prefer files under 5MB. You can reduce size by decreasing the dimensions or reducing the number of uploaded frames."
        }
      ],
      enFaqUsage: [
        {
          q: 'Can I change the GIF dimensions after uploading?',
          a: 'Yes, you can easily switch between dimensions or use our smart ratio templates (1:1, 9:16) from the "General Settings" tab at any time.'
        },
        {
          q: 'How do I save the GIF on an iPhone?',
          a: 'After clicking "Download Final GIF", the file will open. Long-press the image and select "Add to Photos". You\'ll find it in the "Animated" album in your photo library.'
        },
        {
          q: 'Can I reorder images after uploading?',
          a: 'Yes! Simply click and drag any frame in the timeline thumbnails at the bottom to reorder your sequence.'
        }
      ],
      enFaqRights: [
        {
          q: 'Is there a watermark on the output files?',
          a: 'No, at SplendApp we believe in supporting creators, so output files are completely watermark-free and belong entirely to you.'
        },
        {
          q: 'How does the tool ensure my image privacy?',
          a: 'The tool works locally in your browser. This means your images are never uploaded to any servers — all rendering happens entirely on your device.'
        }
      ],

      // ─── English Guide Steps ───────────────────────────────────
      enGuideSteps: [
        {
          title: 'Upload Images',
          desc: 'Click the drop zone and select all the images you want to convert. They will appear as frames in the timeline.',
          placeholder: '[Tip: You can drag and drop multiple images at once]',
          keywords: 'upload images select files'
        },
        {
          title: 'Arrange the Sequence',
          desc: 'Click and drag the thumbnails in the timeline to rearrange them. You can delete frames you don\'t want by clicking the "X".',
          placeholder: '[Tip: Click on a thumbnail to make it the active frame in the editor]',
          keywords: 'drag drop sequence arrange timeline'
        },
        {
          title: 'Add Text & Settings',
          desc: 'Use the General Settings to adjust the animation delay. Use Scene Settings to add text, colors, and backgrounds to individual frames.',
          placeholder: '[Tip: Use the smart ratio buttons for quick social media sizing]',
          keywords: 'text font color position delay speed'
        },
        {
          title: 'Final Download',
          desc: 'After checking the live preview, click "Download Final GIF" to generate and save the file directly to your device.',
          placeholder: '[Tip: Processing might take a moment depending on how many frames you have]',
          keywords: 'download save export final'
        }
      ],

      // ─── Arabic FAQ Data ───────────────────────────────────────
      arFaqTechnical: [
        {
          q: 'لماذا تبدو جودة الصور أقل قليلاً بعد تحويلها لـ GIF؟',
          a: 'تعتمد صيغة GIF على لوحة ألوان محدودة (256 لوناً فقط). للحصول على أفضل جودة، ننصح باستخدام صور ذات خلفيات موحدة وتقليل التدرجات اللونية المعقدة.'
        },
        {
          q: 'هل تدعم الأداة الصور ذات الخلفية الشفافة (PNG)؟',
          a: 'نعم، الأداة تحافظ على شفافية الصور المرفوعة بصيغة PNG، ويمكنك أيضاً تغيير لون الخلفية لأي إطار من الإعدادات.'
        },
        {
          q: 'ما هو الحد الأقصى لحجم ملف الـ GIF الناتج؟',
          a: 'لا نضع قيوداً، ولكن منصات مثل واتساب تفضل الملفات الأقل من 5 ميجابايت. يمكنك تقليل الحجم عن طريق تصغير الأبعاد أو تقليل عدد الإطارات.'
        }
      ],
      arFaqUsage: [
        {
          q: 'هل يمكنني تغيير أبعاد الـ GIF بعد الرفع؟',
          a: 'نعم، يمكنك تغيير الأبعاد يدوياً أو استخدام القوالب الذكية (مثل 1:1 أو 9:16) من تاب "الإعدادات العامة" في أي وقت.'
        },
        {
          q: 'كيف أقوم بحفظ الـ GIF على جهاز iPhone؟',
          a: 'بعد الضغط على "تحميل"، اضغط مطولاً على الصورة الناتجة ثم اختر "Add to Photos". ستجدها في ألبوم "الصور المتحركة" (Animated) في معرض الصور.'
        },
        {
          q: 'هل يمكنني تغيير ترتيب الصور بعد رفعها؟',
          a: 'نعم! يمكنك ببساطة سحب وإفلات أي صورة في شريط الإطارات السفلي لإعادة ترتيب المشاهد كما تحب.'
        }
      ],
      arFaqRights: [
        {
          q: 'هل توجد علامة مائية (Watermark) على الملفات؟',
          a: 'لا، نحن في سبلينداب نؤمن بدعم أصحاب المشاريع؛ لذا الملفات الناتجة خالية تماماً من أي علامات مائية وتخصك وحدك.'
        },
        {
          q: 'كيف تضمن الأداة خصوصية صوري؟',
          a: 'الأداة تعمل محلياً (Local) في المتصفح، مما يعني أن صورك لا تُرفع أبداً إلى أي خوادم، وتتم المعالجة بالكامل على جهازك الشخصي.'
        }
      ],

      // ─── Arabic Guide Steps ────────────────────────────────────
      arGuideSteps: [
        {
          title: 'مرحلة الرفع',
          desc: 'اضغط على منطقة السحب واختر جميع الصور التي تريد تحويلها. ستظهر الصور كإطارات في الشريط السفلي.',
          placeholder: '[تلميح: يمكنك سحب وإفلات عدة صور دفعة واحدة]',
          keywords: 'رفع الصور اختيار ملفات'
        },
        {
          title: 'ترتيب التسلسل',
          desc: 'قم بسحب الإطارات المصغرة في الشريط السفلي لإعادة ترتيبها. يمكنك حذف أي إطار غير مرغوب فيه بالضغط على علامة "✕".',
          placeholder: '[تلميح: اضغط على أي صورة مصغرة لجعلها المشهد النشط في المحرر]',
          keywords: 'ترتيب تسلسل سحب إفلات إطارات'
        },
        {
          title: 'النصوص والإعدادات',
          desc: 'استخدم "الإعدادات العامة" لتغيير سرعة الحركة. واستخدم "إعدادات المشهد" لإضافة نصوص وألوان وخلفيات لكل إطار على حدة.',
          placeholder: '[تلميح: استخدم أزرار الأبعاد الذكية لتجهيز الصورة لمنصات التواصل]',
          keywords: 'نص خط لون موقع سرعة أبعاد'
        },
        {
          title: 'التحميل النهائي',
          desc: 'بعد التأكد من المعاينة الحية، اضغط على "تحميل الملف" لتوليد صورة الـ GIF وحفظها مباشرة على جهازك.',
          placeholder: '[تلميح: قد تستغرق المعالجة لحظات حسب عدد الإطارات المرفوعة]',
          keywords: 'تحميل حفظ تصدير نهائي'
        }
      ]
    }
  },

  computed: {
    filteredStepsAr() {
      if (!this.guideSearch) return this.arGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.arGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    },
    filteredStepsEn() {
      if (!this.guideSearch) return this.enGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.enGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    }
  },

  watch: {
    '$store.state.currentLanguage': function (newLanguage) {
      this.currentLanguage = newLanguage;
      this.openFaq = null;
      this.guideSearch = '';
      
      if (this.currentLanguage == 'en') {
        this.$router.push({ name: 'gif-converter-en' }).catch(()=>{});
      } else {
        this.$router.push({ name: 'gif-converter-ar' }).catch(()=>{});
      }
    }
  }
}
</script>

<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

.ad-banner {
  max-width: 100%;
  border-radius: 12px;
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

[dir="rtl"] .search-box {
  input {
    padding: 15px 20px 15px 45px;
  }
  .search-icon {
    right: auto;
    left: 15px;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

[dir="rtl"] .step-card {
  border-right: none;
  border-left: 5px solid #3a7afe;
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
  display: none;
}

.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 769px) {
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
